import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock } from 'lucide-react';
const scrollToCheckout = () => {
  const checkoutButton = document.getElementById('checkout-button');
  if (checkoutButton) {
    checkoutButton.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};
export function Hero() {
  return <section className="relative bg-white text-gray-900 overflow-hidden pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-100">
      <div className="container mx-auto px-4 relative z-10" data-id="element-101">
        <div className="flex flex-col items-center text-center" data-id="element-102">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-4xl" data-id="element-103">
            <h1 className="text-4xl lg:text-6xl font-extrabold leading-tight mb-8 text-black" data-id="element-104">
              MEGAPACK SEGURIDAD E HIGIENE EN EL AULA
            </h1>

            {/* Image Content - Directly below title */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative mb-8 max-w-2xl mx-auto" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/7tjKCaLHTHF2LYVfCCLRXN/WhatsApp_Image_2026-01-03_at_21.25.56.jpg" alt="Megapack Seguridad e Higiene Producto Completo" className="w-3/4 md:w-2/3 h-auto mx-auto" data-id="element-106" />
            </motion.div>

            <p className="text-xl lg:text-2xl text-gray-700 mb-6 font-medium" data-id="element-107">
              La herramienta todo-en-uno definitiva para resolver TODA tu
              cursada anual.
            </p>

            <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-108">
              Diseñado para docentes de escuelas técnicas, formación profesional
              e instructores que quieren recuperar su tiempo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" data-id="element-109">
              <motion.button onClick={scrollToCheckout} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-orange-500 text-white text-lg font-bold py-3 px-6 rounded-lg shadow-lg hover:bg-orange-600 transition-colors uppercase tracking-wide cursor-pointer" data-id="element-110">
                SÍ, QUIERO RESOLVER MI AÑO
              </motion.button>
            </div>

            <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-gray-600" data-id="element-111">
              <div className="flex items-center gap-2" data-id="element-112">
                <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-113" />
                <span data-id="element-114">Compra 100% segura</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-115">
                <Clock className="w-5 h-5 text-orange-500" data-id="element-116" />
                <span data-id="element-117">Acceso inmediato</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}